



























































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import AiAdviceSearch from '@/app/components/AiAdvice/AiAdviceSearch.vue'
import AiAdviceListHeader from '@/app/components/AiAdvice/AiAdviceListHeader.vue'
import AiAdviceList from '@/app/components/AiAdvice/AiAdviceList.vue'
/* api */
import aiAdviceApi from '@/app/model/api/aiAdviceApi'
/* module */
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    AiAdviceSearch,
    AiAdviceListHeader,
    AiAdviceList
  }
})
export default class masterAiAdvice extends Vue {
  private count: number = 0
  private notDataMessage: boolean = false
  private showLoading: boolean = true
  private aiAdviceData: any = {}

  created () {
    this.getAiAdviceList()
  }

  private getAiAdviceList () {
    (async () => {
      /* 初期表示は名前の昇順 */
      const data = {
        word: this.$store.state.aiAdviceState.searchText,
        order_name: this.$store.state.aiAdviceState.orderName,
        sort: this.$store.state.aiAdviceState.sortAsc
      }
      const result = await aiAdviceApi.getAiAdvice(data)

      if (result.isOk()) {
        const payload = result.getPayload()
        this.aiAdviceData = payload.ai_advice
        this.count = payload.result_count

        this.notDataMessage = this.count === 0
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private doAiAdviceSort (data: string) {
    this.showLoading = true
    this.scrollTop()

    let sort = true
    if (data === this.$store.state.aiAdviceState.orderName) {
      sort = !this.$store.state.aiAdviceState.sortAsc
    }

    this.$store.commit('aiAdviceState/setOrderName', data)
    this.$store.commit('aiAdviceState/setSortAsc', sort)
    this.getAiAdviceList()
  }

  private changeList () {
    this.showLoading = true
    this.$store.commit('aiAdviceState/setOrderName', 'created_at')
    this.$store.commit('aiAdviceState/setSortAsc', false)
    this.scrollTop()
    this.getAiAdviceList()
  }

  private scrollTop () : any {
    const aiAdviceArea: any = document.getElementById('listContainer')!
    aiAdviceArea.scrollTop = 0
  }
}
